import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./similarProducts.module.css";
import { LeftArrow, RightArrow } from "../../../Svg";
import { useNavigate } from "react-router-dom";
import { useCurrency } from '../../context/CurrencyContext';
import RecentlyViewedProductImage from "./RecentlyViewedProductImage";
import {
  RECENTLY_VIEWED_PRODUCTS_CHANGED_EVENT,
  RECENTLY_VIEWED_PRODUCTS_KEY,
  readRecentlyViewedProducts
} from "../../../utils/recentlyViewedProducts";



const CustomArrow = ({ className, onClick, arrowDirection }) => {
  return (
    <div
      className={`${className} ${styles.customArrow} ${arrowDirection === "left" ? styles.leftArrow : styles.rightArrow
        }`}
      onClick={onClick}
    >
      {arrowDirection === "left" ? <LeftArrow /> : <RightArrow />}
    </div>
  );
};

const RecentlyViewed = () => {

  const navigate = useNavigate();
  const [recentlyViewed, setRecentlyViewed] = useState(() => readRecentlyViewedProducts());
  const { formatPrice } = useCurrency();


  useEffect(() => {
    const fetchRecentlyViewed = () => {
      setRecentlyViewed(readRecentlyViewedProducts());
    };

    const handleStorage = (event) => {
      if (!event.key || event.key === RECENTLY_VIEWED_PRODUCTS_KEY) {
        fetchRecentlyViewed();
      }
    };

    // Fetch data on mount
    fetchRecentlyViewed();

    // Listen for changes in localStorage
    window.addEventListener("storage", handleStorage);
    window.addEventListener(RECENTLY_VIEWED_PRODUCTS_CHANGED_EVENT, fetchRecentlyViewed);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener(RECENTLY_VIEWED_PRODUCTS_CHANGED_EVENT, fetchRecentlyViewed);
    };
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Display 4 products per slide
    slidesToScroll: 1,

    prevArrow: <CustomArrow arrowDirection="left" />,
    nextArrow: <CustomArrow arrowDirection="right" />,
    adaptiveHeight: true,
    autoplay: true, // Enable auto-play
    autoplaySpeed: 2000, // Set auto-play speed in milliseconds (3 seconds)
    pauseOnHover: true, // Pause auto-play on hover
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 546,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (!recentlyViewed?.length) {
    return null;
  }

  return (
    <div className={styles.sliderContainer}>
      <h2 className={styles.heading}>Recently viewed</h2>
      <Slider {...settings} className={styles.slickSlider} style={{ gap: "16px" }}>
        {recentlyViewed.map((product) => (
          <div key={product.id} className={styles.productCard}
            onClick={() => {
              navigate(`/prodDescription/${product?.id}`);
              window.scrollTo(0, 0);
            }}
            style={{ cursor: 'pointer' }}
          >
            <div className={styles.productmain}>
              <div className={styles.productimgcont}>
                <div key={product.id} className={styles.productImage}>
                  <RecentlyViewedProductImage
                    src={product?.image}
                    alt={product.name}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <p className={styles.productName}>{product?.name}</p>
                <p className={styles.productPrice}>
                  <span className={styles.currentPrice}>{formatPrice(product.sellingPrice)}</span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RecentlyViewed;
